export default "__VITE_ASSET__D8PC_vOz__"